<template>
  <div class="card mb-25 border-0 rounded-0 bg-white letter-spacing">
    <div
      class="card-header"
    >
      <h5>{{ rowNote.note_ref }}</h5>
      <br />
      <p>
        Date de création :
        <b v-if="rowNote.created_at"> {{ getDate(rowNote.created_at) }}</b> |
        ENVOIE :
        <b>
          {{ rowNote.sending_zone_name }} {{ rowNote.sending_agency_name }}</b
        >
        | RECEPTION :<b>
          {{ rowNote.reception_zone_name }}
          {{ rowNote.reception_agency_name }}
        </b>
      </p>
    </div>
  </div>

  <div class="card mb-25 border-0 rounded-0 bg-white letter-spacing">
    <div class="card-header">
      <h5>List des nouveaux colis</h5>
    </div>
    <div class="card-body p-15 p-sm-20 p-md-25">
      <div class="row">
        <div
          class="col-md-6 d-flex align-items-center justify-content-start mb-1 mb-md-0"
        >
          <label>Voir</label>
          <v-select
            v-model="users1.per_page"
            :options="[10, 25, 50, 100]"
            :clearable="false"
            class="per-page-selector d-inline-block mx-50"
            @update:modelValue="getRows1()"
          />
          <label>{{ users1.total }} entités</label>
        </div>

        <div class="col-12">
          <div class="custom-search d-flex justify-content-end">
            <div class="form-group">
              <div class="d-flex align-items-center">
                <input
                  placeholder="Chercher"
                  type="text"
                  @input="getRows1()"
                  v-model="users1.searchTerm"
                  class="form-control"
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <vue-good-table
        :columns="columns"
        :rows="rows1"
        >
        <!-- <div slot="emptystate"></div> -->
        <template #emptystate>
          <center>Aucune entrées correspondants trouvés</center>
        </template>
        <template #table-row="props">
          <template v-if="props.column.field === 'code'">
            <h6 class="text-warning" v-if="props.row.replace == 1">
              {{ props.row.code }}
              <i class="flaticon-refresh"></i>
            </h6>
            <h6 class="text-info" v-else-if="props.row.partial == 1">
              {{ props.row.code }}
              <i class="flaticon-corner-down-left"></i>
            </h6>
            <h6 v-else>
              {{ props.row.code }}
            </h6>
          </template>
          <template v-else-if="props.column.field === 'status'">
            <div
              v-if="
                props.row.status == 'IN_PROGRESS' &&
                props.row.status_second &&
                globalStore.globalHelper(props.row.status_second).name
              "
              class="rounded-pill fs-13 badge text-bg-black custom-badge"
              :style="{
                '--dynamic-bg': globalStore.globalHelper(props.row.status_second).code_color,
              }"
            >
              {{ globalStore.globalHelper(props.row.status_second).name }}
            </div>
            <div
              v-else
              class="rounded-pill fs-13 badge text-bg-black custom-badge"
              :style="{ '--dynamic-bg': props.row.code_color }"
            >
              {{ props.row.s_name }}
            </div>
          </template>
          <template v-else-if="props.column.field === 'price'">
            <b>{{ props.row.price }}</b> {{ $devis }}
          </template>
          <template v-else-if="props.column.field === 'updated_at'">
            <span class="text-nowrap">
              {{ getDate(props.row.updated_at) }}
            </span>
          </template>
          <span v-else-if="props.column.field === 'actions'">
            <div class="dropdown">
              <button
                class="dropdown-toggle lh-1 bg-transparent border-0 shadow-none p-0 transition"
                type="button"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                <i class="flaticon-dots"></i>
              </button>
              <ul class="dropdown-menu">
                <li>
                  <a
                    class="dropdown-item"
                    @click="showDetailSuivi(props.row.id)"
                  >
                    <i
                      class="flaticon-clock lh-1 me-8 position-relative top-1"
                    ></i>
                    Historique
                  </a>
                </li>
                <li>
                  <a class="dropdown-item" @click="showDetails(row)">
                    <i
                      class="flaticon-view lh-1 me-8 position-relative top-1"
                    ></i>
                    Infos
                  </a>
                </li>
              </ul>
            </div>
          </span>

          <span v-else>
            {{ props.formattedRow[props.column.field] }}
          </span>
        </template>
      </vue-good-table>
      <div class="row">
        <div class="col-12">
          <div>
            <div class="col-12">
              <PaginatorContent
                :pagination="users1"
                :offset="9"
                @paginate="getRows1"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="card mb-25 border-0 rounded-0 bg-white letter-spacing">
    <div class="card-header">
      <h5>Scan code suivi</h5>
    </div>
    <div class="card-body p-15 p-sm-20 p-md-25">
      <form v-on:submit.prevent="SearchColis">
        <div class="custom-search">
          <div class="row">
            <div class="col-md-8">
              <div class="form-group">
                <label>Code Suivi :</label>
                <input
                  placeholder="Code Suivi"
                  type="text"
                  id="scanFocus"
                  v-model="codeColis"
                  class="form-control"
                />
              </div>
            </div>
            <div class="col-md-4">
              <button
                class="btn btn-success me-3 mb-3 mt-3"
                type="submit"
              >
                <i class="ph ph-scan"></i>
              </button>
              <button
                class="btn btn-primary me-3 mb-3 mt-3"
                @click="refreshAll"
              >
                <i class="ph ph-arrows-clockwise"></i>
              </button>
            </div>
            <div class="col-12">
              <hr />
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>

  <div class="card mb-25 border-0 rounded-0 bg-white letter-spacing">
    <div class="card-header">
      <h5>List des colis ajoutés</h5>
    </div>
    <div class="card-body p-15 p-sm-20 p-md-25">
      <div class="row">
        <div
          class="col-md-6 d-flex align-items-center justify-content-start mb-1 mb-md-0"
        >
          <label>Voir</label>
          <v-select
            v-model="users2.per_page"
            :options="[10, 25, 50, 100]"
            :clearable="false"
            class="per-page-selector d-inline-block mx-50"
            @update:modelValue="getRows2()"
          />
          <label>{{ users2.total }} entités</label>
        </div>
        <div class="col-12" md="6">
          <div class="custom-search d-flex justify-content-end">
            <div class="form-group">
              <div class="d-flex align-items-center">
                <input
                  placeholder="Chercher"
                  type="text"
                  v-model="users2.searchTerm"
                  @input="getRows2()"
                  class="form-control"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <vue-good-table
        :columns="columns"
        :rows="rows2"
        >
        <!-- <div slot="emptystate"></div> -->
        <template #emptystate>
          <center>Aucune entrées correspondants trouvés</center>
        </template>
        <template #table-row="props">
          <template v-if="props.column.field === 'code'">
            <h6 class="text-warning" v-if="props.row.replace == 1">
              {{ props.row.code }}
              <i class="flaticon-refresh"></i>
            </h6>
            <h6 class="text-info" v-else-if="props.row.partial == 1">
              {{ props.row.code }}
              <i class="flaticon-corner-down-left"></i>
            </h6>
            <h6 v-else>
              {{ props.row.code }}
            </h6>
          </template>
          <template v-else-if="props.column.field === 'status'">
            <div
              v-if="
                props.row.status == 'IN_PROGRESS' &&
                props.row.status_second &&
                globalStore.globalHelper(props.row.status_second).name
              "
              class="rounded-pill fs-13 badge text-bg-black custom-badge"
              :style="{
                '--dynamic-bg': globalStore.globalHelper(props.row.status_second).code_color,
              }"
            >
              {{ globalStore.globalHelper(props.row.status_second).name }}
            </div>
            <div
              v-else
              class="rounded-pill fs-13 badge text-bg-black custom-badge"
              :style="{ '--dynamic-bg': props.row.code_color }"
            >
              {{ props.row.s_name }}
            </div>
          </template>
          <template v-else-if="props.column.field === 'updated_at'">
            <span class="text-nowrap">
              {{ getDate(props.row.updated_at) }}
            </span>
          </template>

          <span v-else-if="props.column.field === 'actions'">
            <div class="dropdown">
              <button
                class="dropdown-toggle lh-1 bg-transparent border-0 shadow-none p-0 transition"
                type="button"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                <i class="flaticon-dots"></i>
              </button>
              <ul class="dropdown-menu">
                <li>
                  <a
                    class="dropdown-item"
                    @click="showDetailSuivi(props.row.id)"
                  >
                    <i
                      class="flaticon-clock lh-1 me-8 position-relative top-1"
                    ></i>
                    Historique
                  </a>
                </li>
                <li>
                  <a class="dropdown-item" @click="showDetails(row)">
                    <i
                      class="flaticon-view lh-1 me-8 position-relative top-1"
                    ></i>
                    Infos
                  </a>
                </li>
              </ul>
            </div>
          </span>

          <span v-else>
            {{ props.formattedRow[props.column.field] }}
          </span>
        </template>
      </vue-good-table>
      <div class="row">
        <div class="col-12" md="6">
          <div>
            <div class="col-12" md="6">
              <PaginatorContent
                :pagination="users2"
                :offset="9"
                @paginate="getRows2"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script  lang="ts">
import { ref, reactive, onMounted } from "vue";
import moment from "moment";
import api from "@/utils/axios";
import { useAppToast } from "@/composables/useAppToast";
import { useGlobalStore } from "@/stores/global";
import { useAuthStore } from "@/stores/auth";
import { watch } from "vue";

export default {
  name: "ShowEditBn",

  props: {
    rowBE: {
      type: Object,
      required: true,
    },
    getRecords: {
      type: Function,
    },
    isOpen:{
      type: Boolean,
    }
  },

  setup: (props) => {
    // State
    const isLoader = ref(true);
    const DetailsColis = ref<any[]>([]);
    const CitiesList = ref<any[]>([]);
    const AgenciesList = ref<any[]>([]);
    const searchTerm1 = ref("");
    const searchTerm2 = ref("");
    const pageLength = ref(10);
    const pageLength2 = ref(10);

    const { showToast } = useAppToast();
    const auth = useAuthStore();
    const user = auth.user;

    const columns = [
      { label: "Code Suivi", field: "code" },
      { label: "Client", field: "customer_name" },
      { label: "Destinataire", field: "receiver" },
      { label: "Date de ramassage", field: "updated_at" },
      { label: "Prix", field: "price" },
      { label: "Ville", field: "city_name" },
      { label: "Actions", field: "actions" },
    ];

    const fields = [
      { key: "parcel_code", label: "Code d'envoi" },
      { key: "situation", label: "Etat" },
      { key: "s_name", label: "Status" },
      { key: "created_at", label: "Date", tdClass: "browserclass" },
      { key: "city_name", label: "Informations" },
      { key: "name", label: "Action par" },
    ];

    const SelectedRows = ref<any[]>([]);
    const SelectedNewRows = ref<any[]>([]);
    const codeColis = ref("");
    const refReception = ref("");
    const rows1 = ref<any[]>([]);
    const rows2 = ref<any[]>([]);
    const rowNote = ref<any>({});
    const ColiDetails = ref<any>({});
    const city = reactive({ id: 0, name: null as string | null });
    const rowID = ref<number | null>(null);
    const row = ref<any>({});

    const globalStore = useGlobalStore();


    // Pagination state
    const users1 = reactive({
      searchTerm: "",
      total: 0,
      per_page: 10,
      from: 1,
      to: 0,
      current_page: 1,
    });
    const users2 = reactive({
      searchTerm: "",
      total: 0,
      per_page: 10,
      from: 1,
      to: 0,
      current_page: 1,
    });

    // Form state
    const form = reactive({
      id: 0,
      code: "",
      price: "",
      phone: "",
      delivered_fees: "",
      returned_fees: "",
      refused_fees: "",
      receiver: "",
      address: "",
      note: "",
    });

    // Helpers
    function getDate(value: string) {
      return moment.utc(String(value)).format("YYYY-MM-DD HH:mm");
    }

    function resolveUserStatusVariant(status: string) {
      if (status === "PICKED_UP") return "warning";
      if (status === "DELIVERED") return "success";
      if (status === "PAID") return "info";
      if (status === "NOT_PAID") return "danger";
      return "primary";
    }

    // Selection handlers
    function onSelectAll(params: any) {
      SelectedRows.value = params.selectedRows;
    }
    function selectionChanged(params: any) {
      SelectedRows.value = params.selectedRows;
    }
    function onSelectAllColis(params: any) {
      SelectedNewRows.value = params.selectedRows;
    }
    function selectionChangedColis(params: any) {
      SelectedNewRows.value = params.selectedRows;
    }

    // API calls
    async function getData() {
      isLoader.value = true;
      try {
        const res = await api.get(`/api/auth/GetNoteSent`, {
          params: { ref: props.rowBE?.note_ref },
        });
        rowNote.value = res.data;
        await getRows1();
        await getRows2();
      } finally {
        isLoader.value = false;
      }
    }

    async function getRows1(page = 1) {
      users1.current_page = page;
        const res = await api.get(
          `/api/auth/ListColiExped?searchTerm=${users1.searchTerm}&page=${users1.current_page}&per_page=${users1.per_page}`,
          { params: { ref: props.rowBE?.note_ref } }
        );
        rows1.value = res.data.users.data;
        Object.assign(users1, { ...res.data.users, searchTerm: users1.searchTerm });
      
    }

    async function getRows2(page = 1) {
      users2.current_page = page;
      const res = await api.get(
        `/api/auth/ListColiReceved?searchTerm=${users2.searchTerm}&page=${users2.current_page}&per_page=${users2.per_page}`,
        { params: { ref: props.rowBE?.note_ref } }
      );
      rows2.value = res.data.users.data;
      Object.assign(users2, { ...res.data.users, searchTerm: users2.searchTerm });
    }

    function showDetailSuivi(id: number) {
      rowID.value = id;
    }
    function showDetails(r: any) {
      row.value = r;
    }
    function showUpdate(coli: any) {
      Object.assign(form, coli);
      city.name = coli.city_name;
      city.id = coli.city_id;
    }

    async function EditColi() {
      let data = new FormData();
      data.append("code", form.code);
      data.append("city_name", city.name || "");
      data.append("city_id", String(city.id));
      data.append("price", form.price);
      data.append("phone", form.phone);
      data.append("address", form.address);
      data.append("note", form.note);
      data.append("delivered_fees", form.delivered_fees);
      data.append("returned_fees", form.returned_fees);
      data.append("refused_fees", form.refused_fees);
      data.append("receiver", form.receiver);

      try {
        const res = await api.post(`/api/auth/coli_edit/${form.id}`, data);
        if (res.data.message === "success") {
          props.getRecords();
          showToast("Les données sont bien sauvegardés", "success");
        }
      } catch {
        showToast("Something went wrong! Veuillez réessayer", "error");
      }
    }

    function refreshAll() {
      getData();
      props.getRecords();
    }

    async function SearchColis() {
      let data = new FormData();
      data.append("ref_note", props.rowBE?.note_ref);
      data.append("code_colis", codeColis.value);
      data.append("UserID", user?.id);

      try {
        const res = await api.post(`/api/auth/AddColiRecevedBe`, data);
        codeColis.value = "";

        if (res.data.message === "success") {
          getData();
          // new Audio(require("@/assets/sound.mp3")).play();
          document.getElementById("scanFocus")?.focus();
          props.getRecords();
        } else if (res.data.message === "not exist") {
          // new Audio(require("@/assets/erro.mp3")).play();
          showToast("Vous ne pouvez pas l'ajouter", "error");
        } else if (res.data.message === "parcel exit") {
          // new Audio(require("@/assets/erro.mp3")).play();
          showToast("Colis déjà existe dans ce bon !", "error");
        }
      } catch {
        showToast("Something went wrong! Veuillez réessayer", "error");
      }
    }



    onMounted(() => {
      console.log("open", props);
      if (props.isOpen) {
         getData();
        refReception.value = props.rowBE?.note_ref;
      }
    });

    watch(
      () => props.rowBE,
      (newVal) => {
        if (newVal && Object.keys(newVal).length > 0) {
          console.log("noteBL updated:", newVal);
          getData();
        }
      },
      { immediate: true }
    );

    return {
      isLoader,
      DetailsColis,
      CitiesList,
      AgenciesList,
      searchTerm1,
      searchTerm2,
      pageLength,
      pageLength2,
      columns,
      fields,
      SelectedRows,
      SelectedNewRows,
      codeColis,
      refReception,
      rows1,
      rows2,
      rowNote,
      ColiDetails,
      city,
      rowID,
      row,
      users1,
      users2,
      form,
      getDate,
      resolveUserStatusVariant,
      onSelectAll,
      selectionChanged,
      onSelectAllColis,
      selectionChangedColis,
      getData,
      getRows1,
      getRows2,
      showDetailSuivi,
      showDetails,
      showUpdate,
      EditColi,
      refreshAll,
      SearchColis,
      globalStore
    };
  },
};
</script>
